module.exports = __webpack_public_path__ + "files/05d1f04b051f703df7a8eae2d323e10d.png";